export function createRequestReducers(keys) {
  const requests = {};

  keys.forEach((key) => {
    requests[key] = {
      loading: false,
      success: false,
      error: null
    };
  });

  return requests;
}

export function requestReducerStart(requests, key) {
  const obj = {
    ...requests
  };

  obj[key] = {
    loading: true,
    success: null,
    error: null
  };

  return obj;
}

export function requestReducerSuccess(requests, key) {
  const obj = {
    ...requests
  };

  obj[key] = {
    loading: false,
    success: true,
    error: null
  };

  return obj;
}

export function requestReducerError(requests, key, error) {
  const obj = {
    ...requests
  };

  obj[key] = {
    loading: false,
    success: false,
    error
  };

  return obj;
}

export function requestReducerClearError(requests, key) {
  const obj = {
    ...requests
  };

  obj[key] = {
    loading: obj[key].loading,
    success: obj[key].success,
    error: null
  };

  return obj;
}


// WEBPACK FOOTER //
// ./src/util/reducers.js